import { ResellerConfigModel } from './reseller-config.model';

export const ResellerConfig: ResellerConfigModel = {
  'ap-south-1': {
    userPoolId: '',
    userPoolClientId: '',
  },
};
